import { TextField, TextFieldProps } from '@mui/material';
import { Field } from 'formik';
import React, { FC } from 'react';
import { withFormik } from './withFormik/withTextfieldFormik';

interface IFormikTextFieldProps {
	name: string;
}

const textWithFormik = withFormik(TextField);

const FormikTextField: FC<IFormikTextFieldProps | TextFieldProps> = ({
	name,
	...rest
}) => <Field name={name} component={textWithFormik} {...rest} />;

export default FormikTextField;
